<template>


<footer :class="bgColor ? bgColor : 'bg-gray-900'" class="fixed w-full inset-x-0 bottom-0 md:flex md:justify-between md:items-center md:px-12 py-4">

  <div class="flex items-center justify-between px-12 md:p-0">

    <div>
        <h1 class="font-ibn-logo tracking-wide lowercase text-base sm:text-lg md:text-2xl text-center text-white"
            :class="isOpen ? 'pb-8' : ''">
            <span id="footer-company-name">{{ title ? title : 'Island Bridge Networks' }}</span>
        </h1>
    </div>

    <div class="md:hidden">
      <button @click="isOpen = !isOpen" type="button" class="text-gray-500 hover:text-white focus:text-white focus:outline-none">
        <svg class="h-6 w-6 fill-current" viewBox="0 0 24 24">
          <path v-if="isOpen" fill-rule="evenodd" d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"/>
          <path v-if="!isOpen" fill-rule="evenodd" d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"/>
        </svg>
      </button>
    </div>
  </div>

  <div :class="isOpen ? 'block' : 'hidden'" class="navbar-links px-8 pt-0 pb-4 md:flex md:p-0">
    <router-link v-if="isOpen" to="/services">Services</router-link>
    <router-link v-if="altMenu || isOpen" to="/contact">Contact</router-link>
    <router-link v-if="!altMenu" :class="isOpen ? '' : 'font-ibn-logo'" to="/ibbs">ibbs</router-link>
    <router-link to="/careers">Careers</router-link>
    <router-link to="/team">Team</router-link>
  </div>

</footer>



</template>

<script>
export default {
    data() {
        return {
            isOpen: false,
        }
    },
    props: {
        title: String,
        altMenu: Boolean,
        bgColor: String,
    }
}
</script>
